import BkPage from '../../Components/ui/BkPage';
import BkPanel from '../../Components/ui/BkPanel';

export type ProfileNotFoundProps = {
  userId?: string;
};

export default function ProfileNotFound({ userId }: ProfileNotFoundProps) {
  return (
    <BkPage className="flex flex-1 items-center justify-center">
      <BkPanel className="w-full max-w-xl text-center">
        <h1 className="mb-2 text-2xl font-bold uppercase tracking-wider text-bk-gold">
          User Not Found
        </h1>
        <p className="text-bk-muted">
          Could not locate any user with the name of &quot;{userId}&quot;
        </p>
      </BkPanel>
    </BkPage>
  );
}
